// reportWebVitals.js

export function reportWebVitals(metric) {
    console.log(metric);
}
